export default __webpack_public_path__ + "static/media/im19.61a80e24.jpg";